import produce from "immer";
import { TabModel } from "../models/tabModel";
import { ADD_TAB, ADD_TAB_LIST, EDIT_TAB, REMOVE_ALL_TABS, REMOVE_TAB, REMOVE_TAB_LIST, REMOVE_TAB_LIST_BY_FORM_ID, SET_TAB, TabActionTypes } from "../types/actions";

const tabReducerDefaultState: TabModel[] = [];

const tabReducer = (state: TabModel[] = tabReducerDefaultState, action: TabActionTypes): TabModel[] => {
    switch (action.type) {
        case ADD_TAB:
            return produce(state, draft => { draft.push(action.tab) });
        case ADD_TAB_LIST:
            return produce(state, draft => { for (let index = 0; index < action.tabs.length; index++) {
                draft.push(action.tabs[index]);
            } });
        case EDIT_TAB:
            return produce(state, draft => { draft[draft.findIndex(tab => tab.id === action.tab.id)] = action.tab; });
        case REMOVE_TAB:
            return produce(state, draft => { draft.splice(draft.findIndex(tab => tab.id === action.id), 1); });
        case REMOVE_TAB_LIST_BY_FORM_ID:
                return produce(state, draft => { return draft.filter(tab => tab.formId !== action.formId) });
        case REMOVE_TAB_LIST:
            return produce(state, draft => {
                for (let index = 0; index < action.tabs.length; index++) {
                    draft.splice(draft.findIndex(tab => tab.id === action.tabs[index].id), 1);
                }
            });
        case SET_TAB:
            return action.tabs;
        case REMOVE_ALL_TABS:
            return produce(state, draft => {return draft = []})
        default:
            return state;
    }
}

export default tabReducer